import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import StakingModalShell from '../StakingModalShell';
import StakingTokenIcon from '../StakingTokenIcon';

const StakeAmountModal = ({ portfolio, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState('');

  const handleMax = () => {
    setAmount(portfolio.maxStake.replace(/,/g, '') || '');
  };

  const footer = (
    <button
      type="button"
      className="staking-btn staking-btn-primary staking-btn-block"
      onClick={() => onSubmit(amount)}
    >
      {t('staking.stake_cta', 'Stake')}
    </button>
  );

  return (
    <StakingModalShell
      title={t('staking.modal_stake_title', 'Stake')}
      onClose={onClose}
      footer={footer}
    >
      <div className="staking-modal-balance-row">
        <div>
          <span className="staking-modal-label">
            {t('staking.wallet_balance', 'Wallet balance')}
          </span>
          <div className="staking-modal-balance-value">
            <StakingTokenIcon symbol={portfolio.stakeTokenSymbol} />
            <span>
              {portfolio.walletBalance} {portfolio.stakeTokenSymbol}
            </span>
          </div>
        </div>
      </div>
      <label className="staking-modal-field staking-modal-field--column">
        <span className="staking-modal-label">{t('staking.amount', 'Amount')}</span>
        <div className="staking-input-row">
          <input
            type="text"
            inputMode="decimal"
            className="staking-input staking-input--inline"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0"
            autoComplete="off"
          />
          <button type="button" className="staking-input-max-btn" onClick={handleMax}>
            {t('staking.use_max', 'MAX')}
          </button>
        </div>
        <div className="staking-input-hints">
          <span>
            {t('staking.min_dot', 'MIN.')}: {portfolio.minStake}
          </span>
          <span>
            {t('staking.max_dot', 'MAX.')}: {portfolio.maxStake}
          </span>
        </div>
      </label>
    </StakingModalShell>
  );
};

export default StakeAmountModal;
